export const BUSINESS_PREMIUM_PLAN_CODE = "premium" as const;
export const LEGACY_BUSINESS_PREMIUM_PLAN_CODES = ["premium", "platinum"] as const;

export type BusinessPremiumFeature = {
  id: string;
  title: string;
  description: string;
};

export const DEFAULT_BUSINESS_PREMIUM_COPY = {
  name: "OZK Business Premium",
  headline: "업체 페이지를 고객이 찾고 행동하는 홈페이지로 만드세요",
  description:
    "인증 업체가 정보·메뉴·사진·주문·배달·영상 채널을 직접 관리하고 성과를 확인할 수 있습니다.",
  cta: "Premium 시작하기",
  features: [
    { id: "storefront", title: "업체 홈페이지", description: "소개, 사진, 메뉴와 최신 정보를 직접 관리합니다." },
    { id: "ordering", title: "주문·픽업·배달 연결", description: "자체 주문과 Uber Eats·DoorDash·Menulog 채널을 연결합니다." },
    { id: "video", title: "YouTube·쇼츠", description: "영상 채널을 업체 페이지에서 바로 보여줍니다." },
    { id: "inquiries", title: "문의·리뷰 관리", description: "고객 문의와 OZK 리뷰 응답을 한곳에서 관리합니다." },
    { id: "analytics", title: "고급 성과 분석", description: "조회, 전화, 길찾기, 주문 등 고객 행동을 확인합니다." },
    { id: "promotion", title: "추천 순환 노출", description: "운영 정책에 따라 검색과 업체 영역에서 추가 노출됩니다." },
    { id: "support", title: "우선 지원", description: "페이지 설정과 운영 문제를 우선 지원합니다." },
  ] satisfies BusinessPremiumFeature[],
};

export function normalizeBusinessPremiumPlan(value: string | null | undefined): "free" | "premium" {
  return value === "premium" || value === "platinum" ? "premium" : "free";
}
